; var cwMjs = window.cwMjs || {};

import lozad from 'lozad';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'ckeditor5/ckeditor5.css';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/pagination';
// init Swiper:
const swiper = new Swiper('.swiper', {
    modules: [Navigation, Pagination, Autoplay],
    // Optional parameters
    loop: true,
    spaceBetween: 30,
    centeredSlides: true,
    autoplay: {
        delay: 8000,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});

const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();


//是否滚动到底部
function scrollPageAtBottom() {
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
    let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    return scrollHeight - (scrollTop + windowHeight) < 1;
}

/**
 * article
 * @type {{commentFlag: boolean, mood: Window.cwMjs.article.mood, ajaxAddArticleMood: Window.cwMjs.article.ajaxAddArticleMood, moodCount: Window.cwMjs.article.moodCount, comment: Window.cwMjs.article.comment, loadActionsData: Window.cwMjs.article.loadActionsData}}
 */
cwMjs.article = {

    ajaxAddArticleMood: function ($item) {
        const id = $item.data('id');
        const mood = $item.data('mood');

        let request = $.ajax({
            url: '/api/v1/articles/' + id + '/moods',
            method: 'post',
            async: 'false',
            dataType: 'json',
            data: {
                mood: mood
            }
        });

        request.done(function (result) {
            // 投票成功后，如果返回了完整的心情数据，使用updateMoodData更新
            if (result.data && result.data.moods) {
                // console.log(result.data.moods);
                cwMjs.article.updateMoodData(result.data.moods);
            }
            else {
                alert(result.message);
            }
        }).fail(function (jqXHR, textStatus) {
            let message = jqXHR.responseJSON.message
            if (message) {
                alert(message);
                return
            }
            alert("投票失败")
        })
    },

    moodCount: function () {
        var $items = $('.js-mood-box .mood_item');
        var maxNum = null;
        $items.each(function () {
            var $this = $(this);
            var tmpNum = Number($this.data('value'));
            if (maxNum === null) {
                maxNum = Number($this.data('value'));
            } else {
                if (maxNum < tmpNum) {
                    maxNum = tmpNum;
                }
            }
        });

        if (maxNum === 0) return;

        $items.each(function () {
            var $this = $(this);
            var val = Number($this.data('value'));
            var H = Math.ceil(val / maxNum * 100);//100:Max-height of pillar ;
            $this.find('.count').text(val).siblings('.pillar').css({ height: 0 }).animate({ height: H + 2 }, 600);
        })
    },

    mood: function () {
        var $items = $('.js-mood-box .mood_item');
        // console.log(this)
        cwMjs.article.moodCount();

        $.each($items, function (index, item) {
            var $item = $(item);
            $item.on('change', '.change_mood', function (e) {
                e.preventDefault();
                if ($items.is('input:checked')) {
                    alert('您已经表过态了。');
                    return;
                }

                cwMjs.article.ajaxAddArticleMood($item);
                $item.addClass('on');
            });
        });
    },

    commentFlag: false,

    comment: function () {
        var $list = $('.ds-service-list li');
        if ($list.length) {
            if (!cwMjs.common.isWeiXin()) {
                $list.find('.ds-weixin').closest('li').addClass('hide');
            }
            cwMjs.article.commentFlag = true;
        }
    },

    /**
     * 加载文章行为数据（点击量、心情数据）
     */
    loadActionsData: function () {
        // console.log('loadActionsData method called!');

        const $viewCount = $('#articleViewCount');
        const $moodBox = $('#articleMoodBox');
        const $mobileLikeBtn = $('.mobile-action-bar .mobile-action-bar__item--like');

        if (!$viewCount.length && !$moodBox.length && !$mobileLikeBtn.length) {
            return;
        }

        const articleId = $viewCount.data('article-id') || $moodBox.data('article-id');
        if (!articleId) {
            return;
        }

        // console.log('Loading article actions data for article ID:', articleId);

        $.ajax({
            url: `/api/v1/articles/${articleId}/actions-data`,
            method: 'POST',
            dataType: 'json',
            success: function (result) {
                if (result.data) {
                    // 更新点击量
                    if ($viewCount.length && result.data.views !== undefined) {
                        $viewCount.find('.count-number').text(result.data.views);
                        // console.log('Updated view count to:', result.data.views);
                    }

                    if ($mobileLikeBtn.length && result.data.digg) {
                        const mobileLiked = Boolean(result.data.digg.is_digged);
                        const mobileCount = Number(result.data.digg.count || 0);
                        $mobileLikeBtn
                            .attr('data-liked', mobileLiked ? '1' : '0')
                            .attr('data-count', mobileCount)
                            .toggleClass('is-active', mobileLiked)
                            .attr('aria-pressed', mobileLiked ? 'true' : 'false');
                        $mobileLikeBtn.find('.icon')
                            .toggleClass('ri-thumb-up-fill', mobileLiked)
                            .toggleClass('ri-thumb-up-line', !mobileLiked);
                        $mobileLikeBtn.find('.count')
                            .text(mobileCount)
                            .toggleClass('is-zero', mobileCount <= 0);
                    }

                    // 更新心情数据
                    if ($moodBox.length && result.data.moods && result.data.moods.moods) {
                        cwMjs.article.updateMoodData(result.data.moods.moods);
                        // console.log('Updated mood data:', result.data.moods.moods);
                    }
                }
            },
            error: function (xhr, status, error) {
                console.error('Failed to load article actions data:', error);
            }
        });
    },

    /**
     * 更新心情数据
     */
    updateMoodData: function (moods) {
        const $moodItems = $('.js-mood-box .mood_item');

        $moodItems.each(function () {
            const $item = $(this);
            const moodField = $item.data('mood');

            // 查找对应的心情数据
            const moodData = moods[moodField];
            if (moodData && moodData.value !== undefined) {
                // 更新数值
                $item.data('value', moodData.value);
                $item.find('.count').text(moodData.value);

                // 重新计算心情柱状图
                cwMjs.article.moodCount();
            }
        });
    },

    renderBottomList: function ($container, items, emptyText) {
        $container.empty();

        if (!Array.isArray(items) || items.length === 0) {
            $container.append(
                $('<li>').addClass('article-bottom-empty').text(emptyText || '暂无内容')
            );
            return;
        }

        $.each(items, function (index, item) {
            if (!item || !item.url || !item.title) {
                return;
            }

            var $link = $('<a>', {
                href: item.url,
                title: item.title,
                target: '_self',
                text: item.title
            });
            $container.append($('<li>').append($link));
        });
    },

    loadBottomBlocks: function () {
        var $latestWrap = $('.js-article-bottom-latest');
        var $hotWrap = $('.js-article-bottom-hot');

        if (!$latestWrap.length) {
            return;
        }

        var articleId = Number($latestWrap.data('article-id') || $('#articleViewCount').data('article-id') || 0);
        if (!articleId) {
            return;
        }

        var latestLimit = Number($latestWrap.data('limit') || 6);
        var hotLimit = Number($hotWrap.data('limit') || 6);
        var poolSize = Number($latestWrap.data('pool-size') || $hotWrap.data('pool-size') || 60);

        $.ajax({
            url: '/api/v1/articles/' + articleId + '/bottom-blocks',
            method: 'GET',
            dataType: 'json',
            data: {
                latest_limit: latestLimit,
                hot_limit: hotLimit,
                pool_size: poolSize
            }
        }).done(function (result) {
            var data = result && result.data ? result.data : {};
            cwMjs.article.renderBottomList($latestWrap, data.latest || [], '暂无推荐文章');
            if ($hotWrap.length) {
                cwMjs.article.renderBottomList($hotWrap, data.hot2days || [], '暂无热点文章');
            }
        }).fail(function () {
            cwMjs.article.renderBottomList($latestWrap, [], '加载失败，请稍后再试');
            if ($hotWrap.length) {
                cwMjs.article.renderBottomList($hotWrap, [], '加载失败，请稍后再试');
            }
        });
    }
};

/**
 * author
 * @type {{switchAuthorIndex: Window.cwMjs.author.switchAuthorIndex}}
 */
cwMjs.author = {
    switchAuthorIndex: function () {

        $('h2 .btn-index').on('click', function (e) {
            e.preventDefault();
            $(this).addClass('hide').siblings('a').removeClass('hide');
            $('.author-list-box').addClass('hide');
            $('.author-index-list').removeClass('hide');
        });

        $('h2 .btn-detail').on('click', function (e) {
            e.preventDefault();
            $(this).addClass('hide').siblings('a').removeClass('hide');
            $('.author-list-box').removeClass('hide');
            $('.author-index-list').addClass('hide');
        });

    }
};

/**
 * cloumn
 */


cwMjs.column = {
    page: 1,
    loadFlag: true,

    init: function () {

    },

    createArticleList: function (articles, type) {
        var $articleWrap = $('.js-article-list');
        if ($articleWrap.length) {
            $.each(articles, function (index, article) {
                $articleWrap.append(cwMjs.column.createArticleElement(article, type));
            });
        }
    },

    createArticleElement: function (article, type) {
        const showClicks = type === 'hot';
        const dateText = showClicks ? (article.newstime + ' · ' + (article.onclick || 0) + '阅') : article.newstime;
        var content = '';
        if (article.titlepic) {
            content += '<li class="item-img-single clearfix">';
            content += '<a class="img-box" href="' + article.url + '" title="' + article.title + '" target="_self">';
            content += '<img src="' + article.titlepic + '" alt="' + article.title + '" >';
            // content += '<img className="lozad" data-src="' + article.titlepic + '" data-placeholder-background="#fefefe" src="' + article.defaultImage + '" alt="' + article.title + '"/>'
            content += '</a >';
            content += '<div class="article-info">';
            content += '<h3><a href="' + article.url + '" title="' + article.title + '" target="_self">' + article.formatTitle + '</a ></h3>';
            content += '<div>';
            content += article.authorRender;
            content += '<span class="date">' + dateText + '</span>';
            content += '</div>';
            content += '</div>';
            content += '</li>';
        } else {
            content += '<li class="item-article clearfix">';
            content += '<div class="article-info">';
            content += '<h3><a href="' + article.url + '" title="' + article.title + '" target="_self">' + article.formatTitle + '</a ></h3>';
            content += '<div>';
            content += article.authorRender;
            content += '<span class="date">' + dateText + '</span>';
            content += '</div>';
            content += '</div>';
            content += '</li>';
        }

        return $(content);
    },

    ajaxGetMoreArticles: function ($loader) {
        // page + 1
        cwMjs.column.page++;
        const type = $loader.data('type')
        const key = $loader.data('key')
        var request = $.ajax({
            url: '/api/v1/articles/more',
            method: 'post',
            async: 'false',
            dataType: 'json',
            data: {
                page: cwMjs.column.page,
                pageSize: 15,
                type: type,
                key: key
            }
        });

        request.done(function (result) {
            let data = result.data;
            let meta = result.meta;
            let last_page = meta.last_page;
            let current_page = meta.current_page;
            if (data.length === 0 || last_page === current_page) {
                cwMjs.column.loadFlag = false;
                $loader.html('没有更多文章了');
            } else {
                setTimeout(function () {
                    cwMjs.column.createArticleList(data, type);
                    $loader.html('查看更多');
                    cwMjs.column.loadFlag = true;
                }, 1000);
            }
        });
    },

    articlesLoadMore: function () {
        let $loader = $('.js-articles-load-more');
        $loader.on('click', function () {
            if (cwMjs.column.loadFlag === true) {
                cwMjs.column.loadFlag = false;
                $loader.html("正在加载中...")
                cwMjs.column.ajaxGetMoreArticles($loader);
            }
        });

        $(window).scroll(function () {
            //滚动条到底部触发
            if (scrollPageAtBottom() && cwMjs.column.loadFlag) {
                cwMjs.column.loadFlag = false;
                $loader.html("正在加载中...")
                cwMjs.column.ajaxGetMoreArticles($loader);
            }
        });
    },

    createAuthorList: function (authors) {
        var $authorWrap = $('.js-author-list');
        if ($authorWrap.length) {
            $.each(authors, function (index, author) {
                var content = '<li class="clearfix">';
                content += ' <a href="' + author.url + '" class="img-box" title="' + author.title + '" target="_self" >';
                content += '<img src="' + author.titlepic + '" alt="' + author.title + '" >';
                content += ' </a >';
                content += '<a href="' + author.url + '" class="author-info" title="' + author.title + '" target="_self" >';
                content += '<h3>' + author.title + '</h3>';
                content += '<div class="title">' + author.ftitle + '</div>';
                content += '<span class="article-count">文章' + author.articleCount + '篇</span>';
                content += '</a >';
                content += '</li>';
                $authorWrap.append($(content));
            });
        }
    },

    ajaxAuthorLoad: function ($loader) {
        cwMjs.column.page++;
        var request = $.ajax({
            url: '/api/v1/authors/more',
            method: 'post',
            async: 'false',
            dataType: 'json',
            data: {
                page: cwMjs.column.page,
                pageSize: 15
            }
        });

        request.done(function (result) {
            let data = result.data;
            let meta = result.meta;
            let last_page = meta.last_page;
            let current_page = meta.current_page;
            if (data.length === 0 || last_page === current_page) {
                $loader.html('没有更多作者了');
            } else {
                cwMjs.column.createAuthorList(data);
                $loader.html('查看更多');
                cwMjs.column.loadFlag = true;
            }
        });
    },

    authorLoad: function () {
        let $loader = $('.js-author-load');
        $loader.on('click', function () {
            if (cwMjs.column.loadFlag) {
                cwMjs.column.loadFlag = false;
                $loader.html("正在加载中...")
                cwMjs.column.ajaxAuthorLoad($loader);
            }
        });

        $(window).scroll(function () {
            //滚动条到底部触发
            if (scrollPageAtBottom() && cwMjs.column.loadFlag) {
                cwMjs.column.loadFlag = false;
                $loader.html("正在加载中...")
                cwMjs.column.ajaxAuthorLoad($loader);
            }
        });
    },

    createTopicList: function (topics) {
        let $topicWrap = $('.js-topic-list');
        if ($topicWrap.length) {
            $.each(topics, function (index, topic) {
                var content = '<li class="item-img-single clearfix">';
                content += '<a class="img-box" href="' + topic.url + '" title="' + topic.ztname + '" target="_self">';
                content += '<img src="' + topic.ztimg + '" >';
                content += ' </a >';
                content += '<div class="article-info">';
                content += '<h3><a href="' + topic.url + '" title="' + topic.ztname + '" target="_self">' + topic.ztname + '</a ></h3>';
                content += '<div>';
                content += '<span class="article-count">文章' + topic.articleCount + '篇</span>';
                content += '</div>';
                content += '</div>';
                content += ' </li>';
                $topicWrap.append($(content));
            });
        }
    },

    ajaxTopicLoad: function ($loader) {
        cwMjs.column.page++;
        let request = $.ajax({
            url: '/api/v1/specials/more',
            method: 'post',
            async: 'false',
            dataType: 'json',
            data: {
                page: cwMjs.column.page,
                pageSize: 15
            }
        });

        request.done(function (result) {
            let data = result.data;
            let meta = result.meta;
            let last_page = meta.last_page;
            let current_page = meta.current_page;
            if (data.length === 0 || last_page === current_page) {
                $loader.html('没有更多专题了');
            } else {
                cwMjs.column.createTopicList(data);
                $loader.html('查看更多');
                cwMjs.column.loadFlag = true;
            }
        });
    },

    topicLoad: function () {
        let $loader = $('.js-topic-load');
        $loader.on('click', function () {
            if (cwMjs.column.loadFlag === true) {
                cwMjs.column.loadFlag = false;
                $loader.html("正在加载中...")
                cwMjs.column.ajaxTopicLoad($loader);
            }
        });

        $(window).scroll(function () {
            //滚动条到底部触发
            if (scrollPageAtBottom() && cwMjs.column.loadFlag) {
                cwMjs.column.loadFlag = false;
                $loader.html("正在加载中...")
                cwMjs.column.ajaxTopicLoad($loader);
            }
        });
    },

    createTagList: function (tags) {
        let $tagWrap = $('.js-tag-list');
        if ($tagWrap.length) {
            $.each(tags, function (index, tag) {
                var content = '';
                if (tag.hasImage && tag.titlepic) {
                    content += '<li class="item-img-single clearfix">';
                    content += '<a class="img-box" href="' + tag.url + '" title="' + tag.tagname + '" target="_self">';
                    content += '<img src="' + tag.titlepic + '" alt="' + tag.tagname + '">';
                    content += '</a>';
                    content += '<div class="article-info">';
                    content += '<h3><a href="' + tag.url + '" title="' + tag.tagname + '" target="_self">' + tag.tagname + '</a></h3>';
                    if (tag.smalltext) {
                        content += '<p class="tag-summary">' + tag.smalltext + '</p>';
                    }
                    content += '<div>';
                    content += '<span class="article-count">' + (tag.className || '未分类') + '</span>';
                    content += '</div>';
                    content += '</div>';
                    content += '</li>';
                } else {
                    content += '<li class="item-article item-tag-noimg clearfix">';
                    content += '<div class="article-info">';
                    content += '<h3><a href="' + tag.url + '" title="' + tag.tagname + '" target="_self">' + tag.tagname + '</a></h3>';
                    if (tag.smalltext) {
                        content += '<p class="tag-summary">' + tag.smalltext + '</p>';
                    }
                    content += '<div>';
                    content += '<span class="article-count">' + (tag.className || '未分类') + '</span>';
                    content += '</div>';
                    content += '</div>';
                    content += '</li>';
                }
                $tagWrap.append($(content));
            });
        }
    },

    ajaxTagLoad: function ($loader) {
        cwMjs.column.page++;
        let request = $.ajax({
            url: '/api/v1/tags/more',
            method: 'post',
            async: 'false',
            dataType: 'json',
            data: {
                page: cwMjs.column.page,
                pageSize: 15,
                cid: $loader.data('cid')
            }
        });

        request.done(function (result) {
            let data = result.data;
            let meta = result.meta;
            let last_page = meta.last_page;
            let current_page = meta.current_page;
            if (data.length === 0 || last_page === current_page) {
                cwMjs.column.loadFlag = false;
                $loader.html('没有更多标签了');
            } else {
                cwMjs.column.createTagList(data);
                $loader.html('查看更多');
                cwMjs.column.loadFlag = true;
            }
        });
    },

    tagLoad: function () {
        let $loader = $('.js-tag-load');
        $loader.on('click', function () {
            if (cwMjs.column.loadFlag === true) {
                cwMjs.column.loadFlag = false;
                $loader.html("正在加载中...")
                cwMjs.column.ajaxTagLoad($loader);
            }
        });

        $(window).scroll(function () {
            //滚动条到底部触发
            if (scrollPageAtBottom() && cwMjs.column.loadFlag) {
                cwMjs.column.loadFlag = false;
                $loader.html("正在加载中...")
                cwMjs.column.ajaxTagLoad($loader);
            }
        });
    }
};

cwMjs.auth = {
    clearErrors: function ($form) {
        $form.find('[data-auth-error-for]').text('');
        $form.find('.js-auth-feedback').attr('hidden', true).removeClass('auth-feedback--error auth-feedback--success').text('');
    },

    setFeedback: function ($form, message, type) {
        var $feedback = $form.closest('.auth-card').find('.js-auth-feedback').first();
        if (!$feedback.length) {
            return;
        }

        $feedback
            .attr('hidden', false)
            .removeClass('auth-feedback--error auth-feedback--success')
            .addClass(type === 'success' ? 'auth-feedback--success' : 'auth-feedback--error')
            .text(message);
    },

    bindForms: function () {
        $('.js-auth-form').each(function () {
            var $form = $(this);

            if ($form.data('authBound')) {
                return;
            }

            $form.data('authBound', true);

            $form.on('submit', function (e) {
                var $submit = $form.find('.js-auth-submit');
                e.preventDefault();

                cwMjs.auth.clearErrors($form);
                $submit.prop('disabled', true).addClass('is-loading');

                $.ajax({
                    url: $form.attr('action'),
                    method: $form.attr('method') || 'POST',
                    data: $form.serialize(),
                    dataType: 'json',
                    headers: {
                        Accept: 'application/json'
                    }
                }).done(function (result) {
                    if (result.message) {
                        cwMjs.auth.setFeedback($form, result.message, 'success');
                    }

                    if (result.redirect_url) {
                        window.setTimeout(function () {
                            window.location.href = result.redirect_url;
                        }, 240);
                    } else {
                        // No redirect - hide form and show success state
                        $form.hide();

                        // If there's a login_url in the response, show a login link
                        if (result.login_url) {
                            var $feedback = $form.closest('.auth-card').find('.js-auth-feedback').first();
                            var $loginLink = $('<div class="auth-links auth-links--single" style="margin-top: 1.5rem;"><a href="' + result.login_url + '" class="auth-link-primary">前往登录</a></div>');
                            $feedback.after($loginLink);
                        }
                    }
                }).fail(function (xhr) {
                    var response = xhr.responseJSON || {};
                    var errors = response.errors || {};
                    var firstMessage = response.message || '提交失败，请稍后再试。';

                    $.each(errors, function (field, messages) {
                        var $error = $form.find('[data-auth-error-for="' + field + '"]').first();
                        var message = $.isArray(messages) ? messages[0] : messages;

                        if ($error.length) {
                            $error.text(message);
                        }

                        if (firstMessage === response.message && message) {
                            firstMessage = message;
                        }
                    });

                    cwMjs.auth.setFeedback($form, firstMessage, 'error');
                }).always(function () {
                    $submit.prop('disabled', false).removeClass('is-loading');
                });
            });
        });
    }
};

cwMjs.member = {
    _ckeditorPromise: null,

    clearErrors: function ($form) {
        var $feedback = $form.closest('.member-card').find('.js-member-feedback').first();
        if (!$feedback.length) {
            $feedback = $('.member-shell .js-member-feedback').first();
        }

        $form.find('[data-form-error-for]').text('');
        $feedback.attr('hidden', true)
            .removeClass('member-feedback--error member-feedback--success')
            .text('');
    },

    setFeedback: function ($form, message, type) {
        var $feedback = $form.closest('.member-card').find('.js-member-feedback').first();
        if (!$feedback.length) {
            $feedback = $('.member-shell .js-member-feedback').first();
        }

        if (!$feedback.length) {
            return;
        }

        $feedback
            .attr('hidden', false)
            .removeClass('member-feedback--error member-feedback--success')
            .addClass(type === 'success' ? 'member-feedback--success' : 'member-feedback--error')
            .text(message);
    },

    bindForms: function () {
        $('.js-member-form').each(function () {
            var $form = $(this);

            if ($form.data('memberBound')) {
                return;
            }

            $form.data('memberBound', true);

            $form.on('submit', function (e) {
                var $submit = $form.find('.js-member-submit').first();
                var hasFiles = ($form.attr('enctype') || '').toLowerCase() === 'multipart/form-data'
                    || $form.find('input[type="file"]').length > 0;
                var ajaxOptions = {
                    url: $form.attr('action'),
                    method: $form.attr('method') || 'POST',
                    dataType: 'json',
                    headers: {
                        Accept: 'application/json'
                    }
                };

                e.preventDefault();

                $form.find('.js-ckeditor').each(function () {
                    var editor = $(this).data('ckeditorInstance');
                    if (editor && typeof editor.getData === 'function') {
                        this.value = editor.getData();
                    }
                });

                cwMjs.member.clearErrors($form);
                $submit.prop('disabled', true).addClass('is-loading');

                if (hasFiles) {
                    ajaxOptions.data = new FormData($form[0]);
                    ajaxOptions.processData = false;
                    ajaxOptions.contentType = false;
                } else {
                    ajaxOptions.data = $form.serialize();
                }

                $.ajax(ajaxOptions).done(function (result) {
                    if (result.message) {
                        cwMjs.member.setFeedback($form, result.message, 'success');
                    }

                    if (result.avatar_url) {
                        $('.js-member-avatar-current').attr('src', result.avatar_url);
                    }

                    if (result.redirect_url) {
                        window.setTimeout(function () {
                            window.location.href = result.redirect_url;
                        }, 260);
                    }
                }).fail(function (xhr) {
                    var response = xhr.responseJSON || {};
                    var errors = response.errors || {};
                    var firstMessage = response.message || '提交失败，请稍后再试。';

                    $.each(errors, function (field, messages) {
                        var $error = $form.find('[data-form-error-for="' + field + '"]').first();
                        var message = $.isArray(messages) ? messages[0] : messages;

                        if ($error.length) {
                            $error.text(message);
                        }

                        if (firstMessage === response.message && message) {
                            firstMessage = message;
                        }
                    });

                    cwMjs.member.setFeedback($form, firstMessage, 'error');
                }).always(function () {
                    $submit.prop('disabled', false).removeClass('is-loading');
                });
            });
        });
    },

    bindEditors: function () {
        var $sources = $('.js-ckeditor');

        if (!$sources.length) {
            return;
        }

        if (!cwMjs.member._ckeditorPromise) {
            cwMjs.member._ckeditorPromise = import('ckeditor5');
        }

        cwMjs.member._ckeditorPromise.then(function (CKEditor) {
            var ClassicEditor = CKEditor.ClassicEditor;
            var Essentials = CKEditor.Essentials;
            var Paragraph = CKEditor.Paragraph;
            var Bold = CKEditor.Bold;
            var Italic = CKEditor.Italic;
            var Underline = CKEditor.Underline;
            var Heading = CKEditor.Heading;
            var Link = CKEditor.Link;
            var List = CKEditor.List;
            var BlockQuote = CKEditor.BlockQuote;
            var Image = CKEditor.Image;
            var ImageToolbar = CKEditor.ImageToolbar;
            var ImageCaption = CKEditor.ImageCaption;
            var ImageStyle = CKEditor.ImageStyle;
            var ImageResize = CKEditor.ImageResize;
            var ImageUpload = CKEditor.ImageUpload;
            var AutoImage = CKEditor.AutoImage;
            var PasteFromOffice = CKEditor.PasteFromOffice;

            function MemberUploadAdapter(loader, uploadUrl) {
                this.loader = loader;
                this.uploadUrl = uploadUrl;
                this.xhr = null;
            }

            MemberUploadAdapter.prototype.upload = function () {
                var _this = this;

                return this.loader.file.then(function (file) {
                    return new Promise(function (resolve, reject) {
                        var xhr = _this.xhr = new XMLHttpRequest();
                        var data = new FormData();

                        xhr.open('POST', _this.uploadUrl, true);
                        xhr.responseType = 'json';
                        xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
                        xhr.setRequestHeader('Accept', 'application/json');

                        xhr.addEventListener('error', function () {
                            reject('图片上传失败，请稍后再试。');
                        });

                        xhr.addEventListener('abort', function () {
                            reject();
                        });

                        xhr.addEventListener('load', function () {
                            var response = xhr.response || {};

                            if (xhr.status >= 400 || !response.url) {
                                reject((response && response.message) || '图片上传失败，请稍后再试。');
                                return;
                            }

                            resolve({
                                default: response.url
                            });
                        });

                        if (xhr.upload) {
                            xhr.upload.addEventListener('progress', function (evt) {
                                if (evt.lengthComputable) {
                                    _this.loader.uploadTotal = evt.total;
                                    _this.loader.uploaded = evt.loaded;
                                }
                            });
                        }

                        data.append('image', file);
                        xhr.send(data);
                    });
                });
            };

            MemberUploadAdapter.prototype.abort = function () {
                if (this.xhr) {
                    this.xhr.abort();
                }
            };

            function MemberUploadAdapterPlugin(editor) {
                var uploadUrl = editor.config.get('memberUpload.url');

                editor.plugins.get('FileRepository').createUploadAdapter = function (loader) {
                    return new MemberUploadAdapter(loader, uploadUrl);
                };
            }

            $sources.each(function () {
                var $source = $(this);
                var statusText = '';
                var uploadUrl;

                if ($source.data('ckeditorBound')) {
                    return;
                }

                uploadUrl = $source.data('uploadUrl');
                $source.data('ckeditorBound', true);

                if (!uploadUrl) {
                    $source.closest('.member-editor').find('.js-editor-status').text('编辑器初始化失败：缺少图片上传地址。');
                    return;
                }

                ClassicEditor.create(this, {
                    licenseKey: 'GPL',
                    plugins: [
                        Essentials,
                        Paragraph,
                        Heading,
                        Bold,
                        Italic,
                        Underline,
                        Link,
                        List,
                        BlockQuote,
                        Image,
                        ImageUpload,
                        AutoImage,
                        ImageToolbar,
                        ImageCaption,
                        ImageStyle,
                        ImageResize,
                        PasteFromOffice,
                        MemberUploadAdapterPlugin
                    ],
                    toolbar: {
                        items: [
                            'heading',
                            '|',
                            'bold',
                            'italic',
                            'underline',
                            '|',
                            'link',
                            'bulletedList',
                            'numberedList',
                            'blockQuote',
                            '|',
                            'uploadImage',
                            '|',
                            'undo',
                            'redo'
                        ],
                        shouldNotGroupWhenFull: true
                    },
                    heading: {
                        options: [
                            { model: 'paragraph', title: '正文', class: 'ck-heading_paragraph' },
                            { model: 'heading2', view: 'h2', title: '大标题', class: 'ck-heading_heading2' },
                            { model: 'heading3', view: 'h3', title: '小标题', class: 'ck-heading_heading3' }
                        ]
                    },
                    link: {
                        defaultProtocol: 'https://',
                        addTargetToExternalLinks: true
                    },
                    image: {
                        toolbar: [
                            'imageTextAlternative',
                            '|',
                            'imageStyle:inline',
                            'imageStyle:block',
                            '|',
                            'resizeImage'
                        ]
                    },
                    memberUpload: {
                        url: uploadUrl
                    },
                    placeholder: $source.attr('placeholder') || '请输入正文内容'
                }).then(function (editor) {
                    $source.data('ckeditorInstance', editor);
                    $source.closest('.member-editor').find('.js-editor-status').text(statusText);

                    editor.model.document.on('change:data', function () {
                        $source.val(editor.getData());
                    });
                }).catch(function (error) {
                    console.error(error);
                    $source.closest('.member-editor').find('.js-editor-status').text('编辑器初始化失败，已回退为普通文本框。');
                    $source.data('ckeditorBound', false);
                });
            });
        }).catch(function (error) {
            console.error(error);

            $sources.each(function () {
                $(this).closest('.member-editor').find('.js-editor-status').text('编辑器资源加载失败，当前已回退为普通文本框。');
            });

            cwMjs.member._ckeditorPromise = null;
        });
    }
};
/**
 * common
 */


cwMjs.common = {
    ajaxSetup: function () {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
    },

    showToast: function (message) {
        var $toast = $('#siteToast');

        if (!$toast.length) {
            $toast = $('<div id="siteToast" class="site-toast" role="status" aria-live="polite"></div>');
            $('body').append($toast);
        }

        $toast.stop(true, true).text(message).addClass('is-visible');
        clearTimeout(window.__siteToastTimer);
        window.__siteToastTimer = setTimeout(function () {
            $toast.removeClass('is-visible');
        }, 1800);
    },

    showNav: function () {
        $('.btn_side').on('click', function () {
            let icon = $(this).find("i");
            // console.log(icon)
            let status = icon.hasClass('open');
            // console.log(status)
            if (status) {
                icon.removeClass('open');
            } else {
                icon.addClass("open")
            }

            $('.nav-container').slideToggle(200);
        });
    },

    memberMenu: function () {
        var $menu = $('.js-member-menu');
        var $body = $('body');

        if (!$menu.length) {
            return;
        }

        $menu.each(function () {
            var $currentMenu = $(this);
            var $toggle = $currentMenu.find('.member-menu__toggle').first();
            var $panel = $currentMenu.find('.member-menu__panel').first();

            function closeMenu() {
                $toggle.removeClass('is-open').attr('aria-expanded', 'false');
                $panel.attr('hidden', true);
            }

            function openMenu() {
                $('.js-member-menu').not($currentMenu).each(function () {
                    $(this).find('.member-menu__toggle').removeClass('is-open').attr('aria-expanded', 'false');
                    $(this).find('.member-menu__panel').attr('hidden', true);
                });

                $('.nav-container').slideUp(200);
                $('.btn_side').find('i').removeClass('open');
                $toggle.addClass('is-open').attr('aria-expanded', 'true');
                $panel.attr('hidden', false);
            }

            $toggle.on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                if ($toggle.hasClass('is-open')) {
                    closeMenu();
                } else {
                    openMenu();
                }
            });

            $panel.on('click', function (e) {
                e.stopPropagation();
            });

            $(document).on('click', function (e) {
                if (!$currentMenu.is(e.target) && $currentMenu.has(e.target).length === 0) {
                    closeMenu();
                }
            });

            $(document).on('keydown', function (e) {
                if (e.key === 'Escape') {
                    closeMenu();
                }
            });

            $body.on('click', '.btn_side', function () {
                closeMenu();
            });
        });
    },

    switchToWeb: function () {
        $('.switch-to-web').on('click', function (e) {
            e.preventDefault();
            var url = window.location.href.toString().replace('m', 'www');
            var list = url.split('/');
            if (list.pop() == 'special') {
                url += '.html';
            }
            Cookies.set('jump_key', 'desk', { domain: 'hswh.org.cn', expires: 1 });
            window.location.href = url;
        });
    },

    switchToPcFromHeader: function () {
        var $btn = $('#j-topc');
        if (!$btn.length) {
            return;
        }

        function parseSeoUrl(rel) {
            var link = document.querySelector('link[rel="' + rel + '"]');
            if (!link || !link.href) {
                return '';
            }

            try {
                return new URL(link.href, window.location.href).href;
            } catch (error) {
                return '';
            }
        }

        $btn.on('click', function (e) {
            e.preventDefault();
            var canonicalUrl = parseSeoUrl('canonical');
            var pcHomeUrl = String($btn.data('pc-home') || '/');
            var targetUrl = canonicalUrl || pcHomeUrl;

            document.cookie = 'fromMobile=true; domain=.wyzxwk.com; path=/; max-age=3600';
            window.location.href = targetUrl;
        });
    },

    isWeiXin: function () {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return true;
        } else {
            return false;
        }
    }

    , fixedFooter: function () {
        initFooter();

        function initFooter() {
            var winH = $(window).height();
            var bodyH = $(document.body).height();
            var footerH = $('footer').height();
            var barH = $('.mobile-action-bar').outerHeight() || 0;
            var footerBottom = barH > 0 ? barH : 0;

            if (winH >= bodyH + footerH || !$('footer').hasClass('fixed-footer') && winH >= bodyH) {
                $('footer').css({ position: 'fixed', width: '100%', left: 0, bottom: footerBottom }).addClass('fixed-footer');
            } else if ($('footer').hasClass('fixed-footer') && winH < bodyH + footerH) {
                $('footer').css({ position: 'static', left: 'auto', bottom: 'auto' }).removeClass('fixed-footer');
            }
        }

        $(window).on('resize', function () {
            initFooter();
        })
    }

    , backTop: function () {
        var $btn = $('.btn-back-top');

        $btn.on('click', function () {
            $('html,body').animate({ scrollTop: 0 }, 400);
        });

        $(window).on('scroll', function () {
            var scrollTop = $(window).scrollTop();
            var limit = 600;

            if (scrollTop > limit && $btn.hasClass('out-hide')) {
                $btn.removeClass('out-hide');
                return;
            }

            if (scrollTop <= limit && !$btn.hasClass('out-hide')) {
                $btn.addClass('out-hide');
            }
        });
    },

    compactHeader: function () {
        var $body = $('body');
        var $shell = $('.site-header-shell');
        var enterLimit = 160;
        var exitLimit = 96;
        var isStuck = $body.hasClass('is-header-stuck');

        if (!$shell.length) {
            return;
        }

        function setStuck(nextState) {
            if (nextState === isStuck) {
                return;
            }

            isStuck = nextState;
            $body.toggleClass('is-header-stuck', nextState);
        }

        function syncHeaderState() {
            var scrollTop;

            if ($body.hasClass('p-article')) {
                setStuck(false);
                return;
            }

            if ($body.hasClass('fixed')) {
                return;
            }

            scrollTop = $(window).scrollTop();

            if (!isStuck && scrollTop >= enterLimit) {
                setStuck(true);
                return;
            }

            if (isStuck && scrollTop <= exitLimit) {
                setStuck(false);
            }
        }

        syncHeaderState();
        $(window).off('scroll.wyzxwkHeader').on('scroll.wyzxwkHeader', syncHeaderState);
    },

    mobileActionBar: function () {
        var $bar = $('.mobile-action-bar');
        var $shareBtn = $bar.find('.mobile-action-bar__item--share');
        var $likeBtn = $bar.find('.mobile-action-bar__item--like');
        var $viewCount = $('#articleViewCount');
        var articleId = $viewCount.data('article-id');
        var likeRequesting = false;

        function applyLikeState(liked, count) {
            $likeBtn.find('.icon')
                .toggleClass('ri-thumb-up-fill', liked)
                .toggleClass('ri-thumb-up-line', !liked);
            $likeBtn.toggleClass('is-active', liked).attr('aria-pressed', liked ? 'true' : 'false');
            $likeBtn.find('.count')
                .text(count)
                .toggleClass('is-zero', count <= 0);
        }

        function syncLikeStateFromBar() {
            var liked = Number($likeBtn.attr('data-liked')) === 1 || $likeBtn.hasClass('is-active');
            var count = Number($likeBtn.attr('data-count') || $likeBtn.find('.count').text() || 0);
            applyLikeState(liked, count);
        }

        async function copyLink() {
            var url = window.location.href;

            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(url);
                return true;
            }

            var input = document.createElement('input');
            input.value = url;
            document.body.appendChild(input);
            input.select();
            input.setSelectionRange(0, input.value.length);
            var copied = document.execCommand('copy');
            document.body.removeChild(input);
            return copied;
        }

        $shareBtn.on('click', async function () {
            var shareData = {
                title: document.title,
                url: window.location.href
            };

            try {
                if (navigator.share) {
                    await navigator.share(shareData);
                    return;
                }

                var copied = await copyLink();
                cwMjs.common.showToast(copied ? '链接已复制' : '请手动复制当前链接');
            } catch (error) {
                if (error && error.name === 'AbortError') {
                    return;
                }

                cwMjs.common.showToast('分享暂不可用，请稍后再试');
            }
        });

        syncLikeStateFromBar();

        $likeBtn.on('click', function () {
            var liked = Number($likeBtn.attr('data-liked')) === 1 || $likeBtn.hasClass('is-active');
            var currentCount = Number($likeBtn.attr('data-count') || $likeBtn.find('.count').text() || 0);

            if (liked) {
                cwMjs.common.showToast('您已赞过');
                return;
            }

            if (!articleId || likeRequesting) {
                return;
            }

            likeRequesting = true;
            $.ajax({
                url: '/api/v1/articles/' + articleId + '/digg',
                method: 'POST',
                dataType: 'json'
            }).done(function (result) {
                var digg = result && result.data && result.data.digg ? result.data.digg : null;
                var nextLiked = digg && digg.is_digged !== undefined ? Boolean(digg.is_digged) : true;
                var nextCount = digg && digg.count !== undefined ? Number(digg.count) : currentCount + 1;

                $likeBtn
                    .attr('data-liked', nextLiked ? '1' : '0')
                    .attr('data-count', nextCount);

                applyLikeState(nextLiked, nextCount);
            }).fail(function () {
                cwMjs.common.showToast('点赞失败，请稍后再试');
            }).always(function () {
                likeRequesting = false;
            });
        });
    },

    open_side: function () {
        var $btn_side = $('header .btn_side');
        var $box_side = $('#nav_model');
        var $body = $('body');

        $box_side.on('click', function () {
            $box_side.removeClass('open');
            $body.removeClass('fixed')
        })

        $btn_side.on('click', function (e) {
            $box_side.addClass('open');
            $body.addClass('fixed');
        })
    }
}

/**
 * index
 */

cwMjs.index = {
    lockVerticalSwipe: function ($slide) {
        $slide.each(function () {
            var el = this;

            if (el.__cwTouchAxisLocked) {
                return;
            }
            el.__cwTouchAxisLocked = true;

            var startX = 0;
            var startY = 0;
            var axis = '';
            var minDistance = 8;
            var listenerOptions = { capture: true, passive: true };

            function getPoint(e) {
                if (!e.touches || e.touches.length !== 1) {
                    return null;
                }
                return e.touches[0];
            }

            el.addEventListener('touchstart', function (e) {
                var point = getPoint(e);
                if (!point) {
                    axis = '';
                    return;
                }

                startX = point.pageX;
                startY = point.pageY;
                axis = '';
            }, listenerOptions);

            el.addEventListener('touchmove', function (e) {
                var point = getPoint(e);
                if (!point) {
                    return;
                }

                var deltaX = point.pageX - startX;
                var deltaY = point.pageY - startY;

                if (!axis) {
                    if (Math.max(Math.abs(deltaX), Math.abs(deltaY)) < minDistance) {
                        e.stopPropagation();
                        return;
                    }

                    axis = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';
                }

                if (axis === 'y') {
                    e.stopPropagation();
                }
            }, listenerOptions);

            function clearAxis(e) {
                if (axis === 'y') {
                    e.stopPropagation();
                }

                axis = '';
            }

            el.addEventListener('touchend', clearAxis, listenerOptions);
            el.addEventListener('touchcancel', clearAxis, listenerOptions);

            el.style.touchAction = 'pan-y';
            el.style.msTouchAction = 'pan-y';
        });
    },

    init: function () {
        var $slide = $('.hot-list .flexslider');
        if (!$slide.length) {
            return;
        }

        cwMjs.index.lockVerticalSwipe($slide);

        $slide.flexslider({
            slideshow: false,
            animationLoop: true,
            animation: 'slide',
            directionNav: false
        });
    }
};


/**
 * init
 */

$(function () {
    // console.log('DOM ready event fired');

    // 确保DOM完全加载后再执行
    $(document).ready(function () {
        // console.log('Document ready event fired');

        setTimeout(function () {
            // console.log('Timeout executed, starting initialization...');

            function init(el, fn) {
                if ($(el).length > 0 && typeof fn === 'function') fn(el);
            }

            init('.js-ajax', cwMjs.common.ajaxSetup);
            //index
            init('.p-index', cwMjs.index.init);

            //article
            init('.js-mood-box', cwMjs.article.mood);
            init('.js-articles-load-more', cwMjs.column.articlesLoadMore);
            init('.js-author-load', cwMjs.column.authorLoad);
            init('.js-topic-load', cwMjs.column.topicLoad);
            init('.js-tag-load', cwMjs.column.tagLoad);
            init('.js-auth-form', cwMjs.auth.bindForms);
            init('.js-member-form', cwMjs.member.bindForms);
            init('.js-ckeditor', cwMjs.member.bindEditors);

            // 加载文章行为数据（点击量、心情数据）
            if ($('#articleViewCount').length || $('#articleMoodBox').length) {
                // console.log('Article elements found, calling loadActionsData...');
                cwMjs.article.loadActionsData();
            }
            init('.js-article-bottom-latest', cwMjs.article.loadBottomBlocks);

            //author
            init('.author-index-list', cwMjs.author.switchAuthorIndex);

            //common
            init('.btn_side', cwMjs.common.showNav);
            init('.js-member-menu', cwMjs.common.memberMenu);
            init('#j-topc', cwMjs.common.switchToPcFromHeader);
            init('.site-header-shell', cwMjs.common.compactHeader);
            init('.mobile-action-bar', cwMjs.common.mobileActionBar);
            // init('footer', cwMjs.common.fixedFooter);
            init('.btn-back-top', cwMjs.common.backTop);

        }, 2);
    });
});
